import {
  put,
  takeEvery
} from "redux-saga/effects";
import {
  createBrowserHistory
} from "history";
import {
  FETCH_NORMALORDERS_INIT_ACTION,
  FETCH_NORMALORDERS_SUCCESS_ACTION,
  FETCH_NORMALORDERS_FAIL_ACTION,
  FETCH_INPROGRESSORDERS_INIT_ACTION,
  FETCH_INPROGRESSORDERS_SUCCESS_ACTION,
  FETCH_INPROGRESSORDERS_FAIL_ACTION,
  FETCH_DELIVEREDORDERS_INIT_ACTION,
  FETCH_DELIVEREDORDERS_SUCCESS_ACTION,
  FETCH_DELIVEREDORDERS_FAIL_ACTION,
  FETCH_CANCELLEDORDERS_INIT_ACTION,
  FETCH_CANCELLEDORDERS_SUCCESS_ACTION,
  FETCH_CANCELLEDORDERS_FAIL_ACTION,
  FETCH_NORMALORDERVIEW_INIT_ACTION,
  FETCH_NORMALORDERVIEW_SUCCESS_ACTION,
  FETCH_NORMALORDERVIEW_FAIL_ACTION,
  EDIT_NORMALORDER_INIT_ACTION,
  EDIT_NORMALORDER_SUCCESS_ACTION,
  EDIT_NORMALORDER_FAIL_ACTION,
  FETCH_NORMALORDERREJECT_INIT_ACTION,
  FETCH_NORMALORDERREJECT_SUCCESS_ACTION,
  FETCH_NORMALORDERREJECT_FAIL_ACTION,
  GET_COMPLETEITEMS_INIT_ACTION,
  GET_COMPLETEITEMS_SUCCESS_ACTION,
  GET_COMPLETEITEMS_FAIL_ACTION,
  CREATE_INVOICE_INIT_ACTION,
  CREATE_INVOICE_SUCCESS_ACTION,
  CREATE_INVOICE_FAIL_ACTION,
  FETCH_NORMALDLVRYSTATUS_INIT_ACTION,
  FETCH_NORMALDLVRYSTATUS_SUCCESS_ACTION,
  FETCH_NORMALDLVRYSTATUS_FAIL_ACTION,
  FETCH_NORMALORDERSHIPPED_INIT_ACTION,
  FETCH_NORMALORDERSHIPPED_SUCCESS_ACTION,
  FETCH_NORMALORDERSHIPPED_FAIL_ACTION,
  CHANGE_NORMALPAYMENTSTATUS_INIT_ACTION,
  CHANGE_NORMALPAYMENTSTATUS_SUCCESS_ACTION,
  CHANGE_NORMALPAYMENTSTATUS_ERROR_ACTION,
  PDF_REPORT_INIT_ACTION,
  PDF_REPORT_SUCCESS_ACTION,
  PDF_REPORT_FAIL_ACTION,
  SEARCH_NORMALORDERITEMS_INIT_ACTION,
  SEARCH_NORMALORDERITEMS_SUCCESS_ACTION,
  SEARCH_NORMALORDERITEMS_FAIL_ACTION
} from "./action";
import {
  push
} from "connected-react-router";
import {
  appConfig
} from "../../config";
import {
  toast,
  Flip
} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


import jsPDF from "jspdf";
import "jspdf-autotable";



var history = createBrowserHistory();

function* fetchNormalOrders(value) {
  // console.log(value);
  const token = localStorage.getItem("token");
  const distID = JSON.parse(localStorage.getItem("userDetails")).id;
  let pageno = !value.value ?
    1 :
    value.value.page === undefined ?
    1 :
    value.value.page;
  let search = !value.value ?
    "" :
    value.value.searchKey === "" ?
    "" :
    value.value.searchKey;
  let filter = !value.value ?
    "" :
    value.value.filter === "" ?
    "" :
    value.value.filter;

  try {
    const res = yield fetch(
      `${appConfig.ip}/purchaseOrder?orgType=chemist&orderTo=${distID}&orderTrk=normal&orderType=purchase&status=created,confirm&payType=${filter}&limit=10&page=${pageno}&search=${search}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_NORMALORDERS_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: FETCH_NORMALORDERS_FAIL_ACTION,
        error: err
      });
    } else {}
  }
}

function* inprogressOrders(value) {
  const token = localStorage.getItem("token");
  const distID = JSON.parse(localStorage.getItem("userDetails")).id;
  let pageno = !value.value ?
    1 :
    value.value.page === undefined ?
    1 :
    value.value.page;
  let search = !value.value ?
    "" :
    value.value.searchKey === "" ?
    "" :
    value.value.searchKey;
  let filter = !value.value ?
    "" :
    value.value.filter === "" ?
    "" :
    value.value.filter;

  try {
    const res = yield fetch(
      `${appConfig.ip}/purchaseOrder?orgType=chemist&orderTo=${distID}&orderTrk=normal&orderType=purchase&status=accepted&payType=${filter}&limit=10&page=${pageno}&search=${search}&sort=-updatedAt`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_INPROGRESSORDERS_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: FETCH_INPROGRESSORDERS_FAIL_ACTION,
        error: err
      });
    } else {}
  }
}

function* deliveredOrders(value) {
  const token = localStorage.getItem("token");
  const distID = JSON.parse(localStorage.getItem("userDetails")).id;
  let pageno = !value.value ?
    1 :
    value.value.page === undefined ?
    1 :
    value.value.page;
  let search = !value.value ?
    "" :
    value.value.searchKey === "" ?
    "" :
    value.value.searchKey;
  let filter = !value.value ?
    "" :
    value.value.filter === "" ?
    "" :
    value.value.filter;

  try {
    const res = yield fetch(
      `${appConfig.ip}/purchaseOrder?orgType=chemist&orderTo=${distID}&orderTrk=normal&orderType=purchase&status=shipmentReady,delivered&payType=${filter}&limit=10&page=${pageno}&search=${search}&sort=-updatedAt`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_DELIVEREDORDERS_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: FETCH_DELIVEREDORDERS_FAIL_ACTION,
        error: err
      });
    } else {}
  }
}

function* cancelledOrders(value) {
  const token = localStorage.getItem("token");
  const distID = JSON.parse(localStorage.getItem("userDetails")).id;
  let pageno = !value.value ?
    1 :
    value.value.page === undefined ?
    1 :
    value.value.page;
  let search = !value.value ?
    "" :
    value.value.searchKey === "" ?
    "" :
    value.value.searchKey;
  let filter = !value.value ?
    "" :
    value.value.filter === "" ?
    "" :
    value.value.filter;

  try {
    const res = yield fetch(
      `${appConfig.ip}/purchaseOrder?orgType=chemist&orderTo=${distID}&orderTrk=normal&orderType=purchase&status=cancelled,rejected&payType=${filter}&limit=10&page=${pageno}&search=${search}&sort=-updatedAt`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_CANCELLEDORDERS_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: FETCH_CANCELLEDORDERS_FAIL_ACTION,
        error: err
      });
    } else {}
  }
}

function* fetchnormalorderview(value) {
  // console.log(value);
  const token = localStorage.getItem("token");
  const orderId = value.value.item.item.id;

  try {
    const res = yield fetch(`${appConfig.ip}/orderDetails?orderId=${orderId}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: FETCH_NORMALORDERVIEW_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: FETCH_NORMALORDERVIEW_FAIL_ACTION,
        error: err
      });
    } else {}
  }
}

function* NormalOrderEdit(value) {
  const token = localStorage.getItem("token");

  const distributorProfId = localStorage.getItem("distributorId");

  let itemList = [];
  let orderId = null;
  value.value.forEach(function (item) {

    // console.log(item);
    orderId = item.orderId.id;
    itemList.push({
      _id: item.id,
      itemCode: item.itemCode.drugCode,
      unitType: item.unitMeasure,
      itemName: item.itemName,
      unitPrice: item.unitPrice,
      unitRate: item.unitRate,
      qntty: item.qntty,
      avlblQntty: item.avlblQntty,
      batchNo: item.batchNo,
      avlble: item.avlble,
      unitType: item.unitType.name,
      orderNo: item.orderNo,
      orderId: item.orderId.id,
      taxAmnt: item.itemCode.taxAmnt,
      unitCost: item.itemCode.unitCost
    });
  });

  try {
    const res = yield fetch(
      `${appConfig.ip}/purchaseOrder/distributorConfirm/` + orderId, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          item: itemList,
          status: "confirm"
        })
      }
    );

    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();
      yield toast.success("Order accepted", {
        autoClose: 3000,
        transition: Flip
      });

      yield put({
        type: EDIT_NORMALORDER_SUCCESS_ACTION,
        payload: resJSON
      });
      yield put({
        type: FETCH_NORMALORDERS_INIT_ACTION
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: EDIT_NORMALORDER_FAIL_ACTION,
        error: err
      });
    } else {}
  }
}

function* fetchnormalordersreject(value) {
  let datas = {
    status: "rejected"
  };

  const id = value.value.item.id;

  const token = localStorage.getItem("token");
  const distributorProfId = localStorage.getItem("distributorId");
  try {
    const res = yield fetch(
      `${appConfig.ip}/purchaseOrder/changeStatus/` + id, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(datas)
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield toast.success("Order rejected", {
        autoClose: 3000,
        transition: Flip
      });
      yield put({
        type: FETCH_NORMALORDERREJECT_SUCCESS_ACTION,
        payload: resJSON
      });

      yield put({
        type: FETCH_NORMALORDERS_INIT_ACTION
      });

      yield put({
        type: FETCH_CANCELLEDORDERS_INIT_ACTION
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: FETCH_NORMALORDERREJECT_FAIL_ACTION,
        error: err
      });
    } else {}
  }
}

//Complete items in the cart retrieval without pagination
function* Totalitemretrieval(value) {
  const token = localStorage.getItem("token");
  let id = value.value.item.id;
  try {
    const res = yield fetch(`${appConfig.ip}/orderDetails?orderId=` + id, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: GET_COMPLETEITEMS_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: GET_COMPLETEITEMS_FAIL_ACTION,
        error: err
      });
    } else {}
  }
}

function* manualInvoice(val) {
  try {
    const token = localStorage.getItem("token");

    const formdata = new FormData();
    formdata.append("attachmentType", 'normal-orders');
    formdata.append("file", val.value.file, "name");

    const resImg = yield fetch(`${appConfig.ip}/attachments/upload`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`
      },
      body: formdata
    });

    if (!resImg.ok) {
      throw resImg;
    } else {
      const resJSON = yield resImg.json();
      const data = {
        orgId: val.value.orgId,
        customerId: val.value.customerId,
        vendorId: val.value.vendorId,
        orderId: val.value.orderId,
        amount: val.value.amount,
        orderNo: val.value.orderNo,
        imgUrl: resJSON.data.documentUrl,
        invType: "chemist",
        orderType: "normal"
      };
      const res = yield fetch(`${appConfig.ip}/invoice`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(data)
      });
      if (!res.ok) {
        throw res;
      } else {
        const resJSON = yield res.json();

        yield put({
          type: CREATE_INVOICE_SUCCESS_ACTION,
          payload: resJSON
        });

        yield put({
          type: FETCH_INPROGRESSORDERS_INIT_ACTION,
        });

        yield toast.success(`Invoice created`, {
          autoClose: 5000,
          transition: Flip
        });
      }
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: CREATE_INVOICE_FAIL_ACTION,
        error: err
      });
    } else {}
    yield toast.error("Technical Issue,invoice not created!", {
      autoClose: 3000,
      transition: Flip
      // position: "top-center",
    });
  }
}

function* fetchNormalorderdlryStatus() {
  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/dlryStatus?sort=sortOrder`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {
        throw Object.assign(res, errJSON);
      }
    } else {
      const resJSON = yield res.json();
      yield put({
        type: FETCH_NORMALDLVRYSTATUS_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: FETCH_NORMALDLVRYSTATUS_FAIL_ACTION,
        error: err
      });
    }
  }
}

function* NormalordersShipped(value) {
  let datas = {
    status: "shipmentReady"
  };

  const id = value.value.item.id;

  const token = localStorage.getItem("token");
  const distributorProfId = localStorage.getItem("distributorId");
  try {
    const res = yield fetch(
      `${appConfig.ip}/purchaseOrder/changeStatus/` + id, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(datas)
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();
      yield toast.success("Order dispatched", {
        autoClose: 3000,
        transition: Flip
      });
      yield put({
        type: FETCH_NORMALORDERSHIPPED_SUCCESS_ACTION,
        payload: resJSON
      });

      yield put({
        type: FETCH_INPROGRESSORDERS_INIT_ACTION
      });

      yield put({
        type: FETCH_DELIVEREDORDERS_INIT_ACTION
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: FETCH_NORMALORDERSHIPPED_FAIL_ACTION,
        error: err
      });
    } else {}
  }
}

function* changePaymentstatusnormal(value) { //For cash on hand dealings
  // console.log(value);
  let datas = {
    invId: value.value.item.invDtls.id,
    invNo: value.value.item.invDtls.invNo,
    orderId: value.value.item.id,
    orderNo: value.value.item.invDtls.orderNo,
    userId: value.value.item.orderFrom.id,
    recptId: value.value.item.orderTo.id,
    paidAmnt: value.value.item.invDtls.amount,
    userMode: "distributor",
    orgId: value.value.item.invDtls.orgId,
    status: "paid"
  };

  const token = localStorage.getItem("token");
  const distributorProfId = localStorage.getItem("distributorId");

  try {
    const res = yield fetch(
      `${appConfig.ip}/payment`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(datas)
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield toast.success("Payment Status Updated", {
        autoClose: 3000,
        transition: Flip
      });
      yield put({
        type: FETCH_DELIVEREDORDERS_INIT_ACTION
      });
      /* yield put({
        type: FETCH_NORMALORDERSHIPPED_SUCCESS_ACTION,
        payload: resJSON
      });

      

      yield put({
        type: FETCH_DELIVEREDORDERS_INIT_ACTION
      }); */
    }
  } catch (err) {
    if (err.ok === false) {
      yield toast.error("Payment Status Update Failed", {
        autoClose: 3000,
        transition: Flip
      });
    } else {}
  }
}



function* fetchPdfReport(value) {
  console.log("4444444444444444444444", value);
  const token = localStorage.getItem("token");
  const orderId = value.value.item.orderDetail.orderId.id;
  const ordername = value.value.item.orderFrom.fullName;
  const ordermob = value.value.item.orderFrom.mobileNo;
  const orderNo = value.value.item.orderNo;
  const email = value.value.item.chmstDtls.email;
  const address = value.value.item.addr + value.value.item.pincode;
  const pharmacy = value.value.item.orderFrom.orgName;
  const city = value.value.item.city;
  console.log('333333333333333333333333333', orderId);

  try {
    const res = yield fetch(`${appConfig.ip}/orderDetails?orderId=${orderId}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      const count = resJSON.count;
      console.log('5555555555555555555555555555', resJSON);
      const doc = new jsPDF();
      const tableColumn = ["#","Item Code", "Item Name", "Quantity", "Availability", ];
      const tableRows = [];
      resJSON.rows.forEach((report,i) => {
        const reportData = [
          i+1,
          report.itemCode.drugCode,
          report.itemCode.drugName,
          report.avlblQntty,
          // report.avlble,
          report.avlble === true
            ? 'Available'
            : 'Not Available'


        ];
        
        tableRows.push(reportData);
        console.log('66666666666666666666666', reportData);
      });
      
    //   doc.autoTable(tableColumn, tableRows, {
    //     startY: 65,
    // });


    doc.autoTable(tableColumn,tableRows, {
      theme : 'grid',
      styles: {
         halign: 'left'
      },
      headerStyles: {
         fillColor: [255, 0, 0],
         halign:'center',
        },
      margin : {
        top: 65
      }
  });

      
   

  

      doc.setFontSize(10);
      doc.text(`Order No : ${orderNo}`, 11, 13,{ float: "right",marginRight:"200px" });
      doc.setFontSize(10);
      doc.text(`Name : ${ordername}`,11, 19,);
      doc.setFontSize(10);
      doc.text(`Pharmacy : ${pharmacy}`, 11, 25,);
      doc.setFontSize(10);
      doc.text(`Mobile : ${ordermob}`, 11, 30);
      doc.setFontSize(10);
      doc.text(`Email : ${email}`, 11, 35);
      doc.setFontSize(10);
      doc.text(`Address : ${address}`, 11, 40,);
      doc.setFontSize(10);
      doc.text(`City : ${city}`, 11, 45,);
    
   
     
      // doc.save(ordername.pdf);
      doc.setFontSize(13);
       doc.text("Item Details", 11, 55);
       doc.setFontSize(12);
       doc.text(`${count} Items`, 11, 60,);
      doc.save(`${ ordername}- ${orderNo}.pdf`);
      doc.save(`${ ordername}- ${orderNo}.pdf`);

      yield put({
        type: PDF_REPORT_SUCCESS_ACTION,
        payload: resJSON
      });

    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: PDF_REPORT_FAIL_ACTION,
        error: err
      });
    } else {}
  }
}




function* searchChemistitems(value) {
  console.log('#########00000000000000000',value);
  const token = localStorage.getItem("token");
 

  let search = !value.value
  ? ""
  : value.value.searchKey === ""
  ? ""
  : value.value.searchKey;

  let orderId = !value.value
  ? ""
  : value.value.data.item.id === ""
  ? ""
  : value.value.data.item.id;
 
  console.log('#########333333333333333333',search);
  console.log('#########444444444444444444',orderId);
 
  
  
  try {
    const res = yield fetch(
      `${appConfig.ip}/orderDetails?orderId=${orderId}&search=${search}`, 

      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      console.log('########resJSONresJSON#', resJSON);
      yield put({
        type: SEARCH_NORMALORDERITEMS_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: SEARCH_NORMALORDERITEMS_FAIL_ACTION, error: err });
    } else {
    }
  }
}






export function* NormalOrdersActionWatcher() {
  yield takeEvery(FETCH_NORMALORDERS_INIT_ACTION, fetchNormalOrders);
  yield takeEvery(FETCH_INPROGRESSORDERS_INIT_ACTION, inprogressOrders);
  yield takeEvery(FETCH_DELIVEREDORDERS_INIT_ACTION, deliveredOrders);
  yield takeEvery(FETCH_CANCELLEDORDERS_INIT_ACTION, cancelledOrders);
  yield takeEvery(FETCH_NORMALORDERVIEW_INIT_ACTION, fetchnormalorderview);
  yield takeEvery(EDIT_NORMALORDER_INIT_ACTION, NormalOrderEdit);
  yield takeEvery(FETCH_NORMALORDERREJECT_INIT_ACTION, fetchnormalordersreject);
  yield takeEvery(GET_COMPLETEITEMS_INIT_ACTION, Totalitemretrieval);
  yield takeEvery(CREATE_INVOICE_INIT_ACTION, manualInvoice);
  yield takeEvery(
    FETCH_NORMALDLVRYSTATUS_INIT_ACTION,
    fetchNormalorderdlryStatus
  );
  yield takeEvery(FETCH_NORMALORDERSHIPPED_INIT_ACTION, NormalordersShipped);
  yield takeEvery(CHANGE_NORMALPAYMENTSTATUS_INIT_ACTION, changePaymentstatusnormal);
  yield takeEvery(PDF_REPORT_INIT_ACTION, fetchPdfReport);
  yield takeEvery(SEARCH_NORMALORDERITEMS_INIT_ACTION, searchChemistitems);
}